import { Parser } from "@siteimprove/alfa-parser";
import { Condition } from "../condition/index.js";
import { Property } from "./feature/index.js";
const { end, left, map } = Parser;
/**
 * {@link https://drafts.csswg.org/css-conditional-3/#at-supports}
 *
 * @remarks
 * Supports query are just a wrapper for a condition.
 *
 * @public
 */
export class Query {
    static of(condition) {
        return new Query(condition);
    }
    _condition;
    constructor(condition) {
        this._condition = condition;
    }
    get condition() {
        return this._condition;
    }
    matches(device) {
        return this._condition.matches(device);
    }
    *iterator() {
        yield* this._condition;
    }
    [Symbol.iterator]() {
        return this.iterator();
    }
    equals(value) {
        return value instanceof Query && value._condition.equals(this._condition);
    }
    toJSON() {
        return { condition: this._condition.toJSON() };
    }
    toString() {
        return this._condition.toString();
    }
}
/**
 * @public
 */
(function (Query) {
    function isQuery(value) {
        return value instanceof Query;
    }
    Query.isQuery = isQuery;
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-media-query}
     */
    Query.parse = left(map(Condition.parse(Property.parse), Query.of), end(() => `Unexpected token`));
})(Query || (Query = {}));
//# sourceMappingURL=query.js.map